import { AnimatePresence, motion, useReducedMotion } from 'motion/react';

import CartItem from '@/components/SunrunShop/CartItem/CartItem';
import useSunrunShopStore from '@/data-store/zustand/hooks/useSunrunShopStore';

import useStyles from './Cart.styles';

export default function CartItems() {
  const { classes } = useStyles();
  const prefersReducedMotion = useReducedMotion();
  const { cart } = useSunrunShopStore('cart');
  const { storefrontCartEnv } = useSunrunShopStore('storefrontCartEnv');

  return (
    <div className={classes.cartItemContainer}>
      <AnimatePresence initial={false}>
        {cart?.lines.edges?.map((item) => (
          <motion.div
            key={item.node.id}
            // Disable scale animations for reduced motion (scaling is a vestibular trigger)
            initial={
              prefersReducedMotion
                ? { opacity: 0 }
                : { height: 0, opacity: 0, scale: 0 }
            }
            animate={{
              height: 'auto',
              opacity: 1,
              scale: 1,
              transition: prefersReducedMotion
                ? { duration: 0.15 }
                : { duration: 0.3, delay: 0.2, ease: 'easeOut' },
            }}
            exit={
              prefersReducedMotion
                ? { opacity: 0 }
                : { height: 0, opacity: 0, scale: 0 }
            }
            transition={
              prefersReducedMotion
                ? { duration: 0.15 }
                : { duration: 0.3, ease: 'easeIn' }
            }
          >
            <CartItem
              item={item.node}
              cartId={cart.id}
              storefrontCartEnv={storefrontCartEnv}
            />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
